var map = {
	"./path_dev.js": "wUjT",
	"./path_prod.js": "xGEj",
	"./path_test.js": "/tLM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "l1Nb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/config ^\.\/path_.*\.js$
// module id = l1Nb
// module chunks = 1